import ProductPage from "../../components/ProductPage";
import { rbiBondsData } from "../../data/productsData";
export default function RBIBonds() { return <ProductPage data={rbiBondsData} />; }